<template lang="pug">
div
  p Select the plan for your business
  select.form-control(v-model='plan')
    option(value='') Select One
    option(value='essential_plan') Essentials - $150/mo
    option(value='ramping_up') RampingUp - $200/mo
    option(value='pro') Pro - $300/mo
    option(value='extreme') Extreme - $400/mo
  button.btn.btn-primary(@click='setUpStripe()') Subscribe
</template>

<script>
import stripe from '../mixins/stripe'

export default {
  mixins: [stripe]
}
</script>



// WEBPACK FOOTER //
// src/components/SubscribeField.vue